import Wait from './wait';

export default Wait;